// Handle confirm reveal
export const confirm = element => new Promise((resolve) => {
  const $element = $(element);
  const $reveal = $('[data-confirm-reveal]');
  const $confirmButton = $reveal.find('[data-confirm-ok]');
  const $abortButton = $reveal.find('[data-confirm-abort]');

  $confirmButton.html($element.attr('data-confirm-ok') || $confirmButton.attr('data-confirm-ok'));
  $abortButton.html($element.attr('data-confirm-abort') || $abortButton.attr('data-confirm-abort'));

  $reveal.find('[data-reveal-content]').html($element.attr('data-confirm'));
  $reveal.foundation('open');

  $confirmButton.on('click', () => {
    $confirmButton.unbind('click');
    $abortButton.unbind('click');
    resolve({ confirmed: true, reveal: $reveal });
  });
  $abortButton.on('click', () => {
    $confirmButton.unbind('click');
    $abortButton.unbind('click');
    resolve({ confirmed: false, reveal: $reveal });
  });
});


// Add loading and success indicator classes to the element, based on the given promise
export const load = (element, promise, options = null) => {
  const opts = Object.assign({
    loadingClass: 'loading',
    loadedClass: 'loaded',
    errorClass: null,
    delay: 1500,
  }, options);

  const $element = $(element);
  $element.addClass(opts.loadingClass);
  $element.removeClass(opts.loadedClass);
  $element.removeClass(opts.errorClass);
  return promise.then((result) => {
    $element.removeClass(opts.loadingClass).addClass(opts.loadedClass);
    setTimeout(() => $element.removeClass(opts.loadedClass), opts.delay);
    return result;
  }).catch(() => {
    $element.removeClass(opts.loadingClass);
    if (opts.errorClass) {
      $element.addClass(opts.errorClass);
    }
  });
};


export const AUTOHIDE_TIMEOUTS = {
  autohide: 8000,
  'autohide--fast': 4000,
  'autohide--slow': 12000,
};


// Show flash messages received in a JSON response
export const handleMessages = (response) => {
  $('.flashmessage.cart').remove();
  $('.flashmessage.checkout').remove();
  if (response && response.messages) {
    response.messages.forEach((message) => {
      const m = $(`<div class="flashmessage ${message.level} ${message.extra_tags}" data-closable>` +
        '    <div class="container"></div>' +
        '    <button class="close-button" type="button" data-close>' +
        '        <i class="icon icon-close-fill" aria-hidden="true"></i>' +
        '    </button>' +
        '</div>');
      m.find('.container').text(message.message);
      $('[data-flashmessages]').append(m);
      $('[data-flashmessages] [data-close]').foundation();
      Object.keys(AUTOHIDE_TIMEOUTS).forEach((key) => {
        if (message.extra_tags.split(' ').indexOf(key) > -1) {
          setTimeout(() => m.remove(), AUTOHIDE_TIMEOUTS[key]);
        }
      });
    });
  }
  return response;
};

$(() => {
  // remove auto hiding messages after page load
  Object.keys(AUTOHIDE_TIMEOUTS).forEach((key) => {
    setTimeout(() => $(`.flashmessage.${key}`).remove(), AUTOHIDE_TIMEOUTS[key]);
  });
});

export default load;
